export enum TransactionErrorTypes {
  NONE = 'none',
  FAILED = 'failed',
  AUTHORIZED = 'authorized',
  PAYMENT_INIT = 'payment_init',
  CANCELLED = 'canceled',
}
